<template>
  <section :class="[bgClass, textColor, 'py-20']">
    <div class="max-w-4xl mx-auto px-6 text-center fade-in-on-scroll" v-scroll-fade>
      <h2 class="text-3xl font-bold mb-4">
        {{ heading }}
      </h2>
      <p class="text-lg sm:text-xl mb-8" :class="subTextColor">
        {{ subtext }}
      </p>
      <a
        href="https://t.me/egbertjoel"
        target="_blank"
        class="px-6 py-3 rounded-lg"
        :class="btnClass"
      >
        {{ buttonText }}
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "CTA",
  props: {
    heading: {
      type: String,
      default: "Ready to bring your strategy to life?"
    },
    subtext: {
      type: String,
      default: "Let’s turn your trading ideas into high-performing tools. Built by a trader, for traders."
    },
    buttonText: {
      type: String,
      default: "Book a Free Consult"
    },
    bg: {
      type: String,
      default: "bg-black"
    },
    textColor: {
      type: String,
      default: "text-white"
    },
    subTextColor: {
      type: String,
      default: "text-gray-300"
    },
    btnClass: {
      type: String,
      default: "bg-white text-black font-semibold border border-white hover:bg-sky-900 hover:text-white transition duration-300"
    }
  },
  computed: {
    bgClass() {
      return this.bg
    }
  }
}
</script>
